import { Movement } from '@studio/models/ptz';
import { Command } from '#~/command/index.js';

/** Choreographed keyboard movement commands. */
export const PtzCommands: { [K in Command]?: Movement } = Object.freeze({
  [Command.PTZ_PAN_LEFT]: Movement.PanLeft,
  [Command.PTZ_PAN_RIGHT]: Movement.PanRight,
  [Command.PTZ_TILT_DOWN]: Movement.TiltDown,
  [Command.PTZ_TILT_UP]: Movement.TiltUp,
  [Command.PTZ_ZOOM_IN]: Movement.ZoomIn,
  [Command.PTZ_ZOOM_OUT]: Movement.ZoomOut
});

/** Quick keyboard movement commands. */
export const QuickCommands: { [K in Command]?: Movement } = Object.freeze({
  [Command.PTZ_PAN_MIN]: Movement.PanLeft,
  [Command.PTZ_PAN_MAX]: Movement.PanRight,
  [Command.PTZ_TILT_MAX]: Movement.TiltUp,
  [Command.PTZ_TILT_MIN]: Movement.TiltDown,
  [Command.PTZ_ZOOM_MAX]: Movement.ZoomIn,
  [Command.PTZ_ZOOM_MIN]: Movement.ZoomOut
});
